import script from "./SALGraficaBarras.vue?vue&type=script&setup=true&lang=js"
export * from "./SALGraficaBarras.vue?vue&type=script&setup=true&lang=js"

import "./SALGraficaBarras.vue?vue&type=style&index=0&id=1c5b79ed&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c5b79ed"]])

export default __exports__